<template>
    <div class="page-pricing">
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-info shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Prices for businesses of any size</h2>
                        <p class="lead text-white">Always know how much to pay</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container mt--8">
                <div class="row justify-content-center">
                    <div class="col-lg-6">
                        <div class="pricing card-group flex-column flex-md-row mb-3">

                            <div class="card card-pricing shadow-lg rounded border-0 text-center mb-4 bg-gradient-info text-white">
                                <div class="card-header bg-transparent">
                                    <h1 class="text-center ls-1 py-3 mb-0">
                                        <b class="text-uppercase text-white">One!</b>
                                    </h1>
                                    <h5 class="text-center">Individual solutions for your business</h5>
                                </div>
                                <div class="card-body px-lg-5">
                                    <div class="text-center">
                                        <p>Full access to the powerful cloud-based <br/>online Insurance System</p>
                                        <div class="display-1">2 <small class="opacity-5">%</small></div>
                                        <p class="text-white opacity-7">and smaller :)</p>
                                        <h5>more premiums &mdash; less payment</h5>
                                    </div>
                                </div>
                                <div class="card-footer bg-transparent text-center">
                                    <router-link to="/contacts" class="text-white">Contact us</router-link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-lg-center px-3 mt-5">
                    <div>
                        <div class="icon icon-shape bg-gradient-white shadow rounded-circle text-primary">
                            <i class="ni ni-money-coins text-primary"></i>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <p>
                            All costs of supporting the technical part are already included, which allows you to
                            concentrate on your business, and not on the information infrastructure of services and
                            maintaining their
                            performance.</p>
                    </div>
                </div>

                <div class="row row-grid justify-content-center">
                    <div class="col-lg-10">
                        <div class="table-responsive">
                            <table class="table tablesorter table mt-5">
                                <thead class>
                                <tr>
                                    <th scope="col" class="px-0 bg-transparent">
                                        <span class="text-light font-weight-700">Features</span>
                                    </th>
                                    <th colspan="2" scope="col" class="text-center bg-transparent">One!</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td class="px-0">Serverless architecture</td>
                                    <td class="text-center" colspan="2">
                                        <b>Full cycle service</b>
                                        <br/>there are no requirements for the availability and quality of the insurance
                                        company's IT&nbsp;infrastructure
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Services location</td>
                                    <td class="text-center" colspan="2">
                                        <img src="img/ill/cloud-logo.svg" height="32" title="Google Cloud"
                                             alt="Google Cloud"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Service resiliency</td>
                                    <td class="text-center" colspan="2"><b>Tier-IV</b></td>
                                </tr>
                                <tr>
                                    <td class="px-0">Data privacy</td>
                                    <td class="text-center" colspan="2"><b>Individual VM&nbsp;instances</b></td>
                                </tr>
                                <tr>
                                    <td class="px-0">File storage</td>
                                    <td class="text-center" colspan="2"><b>Google Cloud Storage</b></td>
                                </tr>
                                <tr>
                                    <td class="px-0">Technical support</td>
                                    <td class="text-center" colspan="2">24/7</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Total amount of&nbsp;premiums</td>
                                    <td class="text-center" colspan="2">no limits</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Number of departments</td>
                                    <td class="text-center" colspan="2">no limits</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Number of users</td>
                                    <td class="text-center" colspan="2">no limits</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Number of products</td>
                                    <td class="text-center" colspan="2">no limits</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Number of operations</td>
                                    <td class="text-center" colspan="2">no limits</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Basic setup</td>
                                    <td class="text-center" colspan="2">free</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Product setup</td>
                                    <td class="text-center" colspan="2">free</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Partner integration</td>
                                    <td class="text-center" colspan="2">free</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Technical support</td>
                                    <td class="text-center" colspan="2">free</td>
                                </tr>
                                <tr>
                                    <td class="px-0">Termination of contracts</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Insurance case</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Digital signature</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Vchasno.ua integration</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">MTSBU integration</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">SMS notification</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Interaction API</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Chatbots in messengers</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">E-commerce</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Embed widgets</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Agent/partner account</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Regular Updates</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Task system</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Own domain name</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Corporate Identity</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-0">Customization</td>
                                    <td class="text-center" colspan="2"><i class="ni ni-check-bold text-success"></i>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <div class="row row-grid justify-content-center">
                    <div class="col-lg-8 text-center">

                        <h2 class="display-3 text-info">Ready to get started?</h2>
                        <p class="lead"></p>
                        <div class="btn-wrapper">
                            <router-link to="/contacts" class="btn btn-info mb-3 mb-sm-0">Contact us</router-link>
                        </div>

                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
	name      : "pricing",
	components: {}
};
</script>
